module.exports = __webpack_public_path__ + "static/cadastro_5-6d8b7de488105f4a777e4c43b7a6cf89.png";